import { Form, Input } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { ChangeEvent, FC } from 'react';

const { Item } = Form;

type TProps = {
  onChange?: (val: string) => void;
};

export const EmailField: FC<TProps> = ({ onChange }) => (
  <Item
    name="email"
    rules={[
      { required: true, message: 'Введите E-mail' },
      { type: 'email', message: 'Введите E-mail в формате login@domen.com ' },
    ]}
    normalize={e => e.trim()}
  >
    <Input
      prefix={<MailOutlined />}
      placeholder="E-mail"
      tabIndex={1}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
    />
  </Item>
);
